/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */


/* ++++++++++ --------------- EXPORT : RATINGS ADDONS PAGE : STYLES --------------- ++++++++++ */
export default theme => ({
  addons: {

  }
});
